import * as SelectedPassenger from './components/SelectedPassenger.css';
import * as LoyaltyNumber from './components/LoyaltyNumber/LoyaltyNumber.css';
import * as PassengerContent from './components/PassengerContent/PassengerContent.css';

export default {
	SelectedPassenger,
	LoyaltyNumber,
	PassengerContent
};
